import { useDispatch, useSelector } from "react-redux";
import { CustomerdashboardIcon } from "../../Assets/svgs/CustomerdashboardIcon";
import { useEffect, useState } from "react";
import { getAssistantList } from "../../Redux/Slice/Assistant/AssistantsListSlice";
import { LineChart } from "@mui/x-charts";
import { getConversationMetrics } from "../../Redux/Slice/Dashboard/CustomerDashboard/GetConversationMetricsSlice";
import { Loader } from "../../Common/Loader";
import { getCountCreditAvailable } from "../../Redux/Slice/Dashboard/CustomerDashboard/GetCountCreditAvailableSlice";
import { getCountCreditUsed } from "../../Redux/Slice/Dashboard/CustomerDashboard/GetCountCreditUsedSlice";
import { getTotalBotFailure } from "../../Redux/Slice/Dashboard/CustomerDashboard/GetTotalBotFailureSlice";
import { getCallSummary } from "../../Redux/Slice/Dashboard/CustomerDashboard/GetCallSummarySlice";
import SmallCoinIcon from "../../Assets/svgs/SmallCoinIcon";

export const CustomerDashboard = () => {
  const dispatch = useDispatch();
  const [assistants, setAssistants] = useState([]);
  const [
    selectedConversationMetricsAssistant,
    setSelectedConversationMetricsAssistant,
  ] = useState("all");
  const [selectedBotFailureAssistant, setSelectedBotFailureAssistant] =
    useState("all");
  const [creditUsedPeriod, setCreditUsedPeriod] = useState("all");
  const [callSummaryPeriod, setCallSummaryPeriod] = useState("all");

  const AssistantList = useSelector((state) => state.assistants.assistantsList);
  const { conversationMetricsData, loading: isLoadingConversationMetricsData } =
    useSelector((s) => s?.conversationMetrics);
  const { creditAvailableData, loading: isLoadingCreditAvailableData } =
    useSelector((s) => s?.countCreditAvailable);
  const { countCreditUsedData, loading: isLoadingCountCreditUsedData } =
    useSelector((s) => s?.countCreditUsed);
  const { totalBotFailureData, loading: isLoadingTotalBotFailureData } =
    useSelector((s) => s?.totalBotFailure);
  const { callSummaryData, loading: isLoadingCallSummaryData } = useSelector(
    (s) => s?.dashboardCallSummary
  );

  useEffect(() => {
    FetchAssistantsList();
  }, []);

  const FetchAssistantsList = async () => {
    dispatch(getAssistantList({ text: "", isDropdown: true }));
  };
  useEffect(() => {
    if (AssistantList && Array.isArray(AssistantList.data)) {
      setAssistants(AssistantList.data);
    }
  }, [AssistantList]);

  const CallSummaryDropDown = [
    { label: "Today", value: "today" },
    { label: "Current Week", value: "currentWeek" },
    { label: "Current Month", value: "currentMonth" },
    { label: "Current Year", value: "currentYear" },
    { label: "All", value: "all" },
  ];

  const conversationMetricsChartLabelData =
    conversationMetricsData &&
    conversationMetricsData?.data &&
    Array.isArray(conversationMetricsData?.data)
      ? conversationMetricsData?.data?.map((metrics) => metrics?.label)
      : [];

  const conversationMetricsChartData =
    conversationMetricsData &&
    conversationMetricsData?.data &&
    Array.isArray(conversationMetricsData?.data)
      ? conversationMetricsData?.data?.map((metrics) => metrics?.value)
      : [];

  const botFailureChartLabelData =
    totalBotFailureData &&
    totalBotFailureData?.data &&
    Array.isArray(totalBotFailureData?.data)
      ? totalBotFailureData?.data?.map((metrics) => metrics?.label)
      : [];

  const botFailureChartData =
    totalBotFailureData &&
    totalBotFailureData?.data &&
    Array.isArray(totalBotFailureData?.data)
      ? totalBotFailureData?.data?.map((metrics) => metrics?.value)
      : [];

  const totalCreditAvailableData = {
    totalCreditsCurrentPlan: creditAvailableData?.data?.planName,
    totalCreditAvailable: parseInt(
      creditAvailableData?.data?.creditsAvailable ?? 0
    ),
    totalCredits: parseInt(creditAvailableData?.data?.totalCredits ?? 0),
    totalCreditPrcentage: `${
      (parseInt(creditAvailableData?.data?.creditsAvailable ?? 0) /
        parseInt(creditAvailableData?.data?.totalCredits ?? 0)) *
      100
    }%`,
  };

  const creditUsedData = {
    creditsAvailable: parseInt(
      countCreditUsedData?.data?.creditsAvailable ?? 0
    ),
    planName: countCreditUsedData?.data?.planName,
    totalCredits: parseInt(countCreditUsedData?.data?.totalCredits ?? 0),
    totalCreditsUsed: parseInt(
      countCreditUsedData?.data?.totalCreditsUsed ?? 0
    ),
    totalCreditPrcentage: `${
      (parseInt(countCreditUsedData?.data?.creditsAvailable ?? 0) /
        parseInt(countCreditUsedData?.data?.totalCredits ?? 0)) *
      100
    }%`,
  };

  const hasChartDataValue = (data = []) => {
    const isVal = data.some((i) => i >= 1);
    return isVal;
  };

  useEffect(() => {
    dispatch(getConversationMetrics(selectedConversationMetricsAssistant));
  }, [selectedConversationMetricsAssistant]);

  useEffect(() => {
    dispatch(getTotalBotFailure(selectedBotFailureAssistant));
  }, [selectedBotFailureAssistant]);

  useEffect(() => {
    dispatch(getCountCreditUsed(creditUsedPeriod));
  }, [creditUsedPeriod]);

  useEffect(() => {
    dispatch(getCallSummary(callSummaryPeriod));
  }, [callSummaryPeriod]);

  useEffect(() => {
    dispatch(getCountCreditAvailable());
  }, []);

  return (
    <div className="page__body">
      {isLoadingConversationMetricsData ||
      isLoadingCreditAvailableData ||
      isLoadingCountCreditUsedData ||
      isLoadingTotalBotFailureData ||
      isLoadingCallSummaryData ? (
        <Loader />
      ) : null}
      <div className="dashboardWrap">
        <div className="dashboardWrap__body">
          <div className="cardRow cardRow__2">
            <div className="col">
              <div className="card radius_0">
                <div className="card__header">
                  <h3 className="title">Conversations</h3>
                  <div className="form__Field">
                    <select
                      id="Chatbot"
                      className="form__select form__select--sm"
                      name="chatbotId"
                      value={selectedConversationMetricsAssistant}
                      onChange={(e) =>
                        setSelectedConversationMetricsAssistant(e.target.value)
                      }
                    >
                      <option selected="" value="" disabled>
                        -Select-
                      </option>
                      <option value="all">All Assistants</option>
                      {assistants
                        ? assistants.map((assistant) => (
                            <option value={assistant.id}>
                              {assistant?.name}
                            </option>
                          ))
                        : ""}
                    </select>
                  </div>
                </div>
                <div className="card__body">
                  <LineChart
                    height={300}
                    colors={["#8b58f1"]}
                    series={[{ data: conversationMetricsChartData }]}
                    xAxis={[
                      {
                        scaleType: "point",
                        data: conversationMetricsChartLabelData,
                        label: "Day of the week",
                      },
                    ]}
                    yAxis={[
                      {
                        tickMinStep: hasChartDataValue(
                          conversationMetricsChartData
                        )
                          ? 1
                          : undefined,
                        label: "Number of conversations",
                      },
                    ]}
                  />
                </div>
              </div>
            </div>
            <div className="col">
              <div className="card card--transparent">
                <div className="dashboardWrap__head dashboardWrap__head__3">
                  <div className="dashboardWrap__head__item">
                    <div className="card card--sad">
                      <div className="card__header">
                        <h3 className="title">Credits Available</h3>
                      </div>
                      <div className="card__info">
                        <div className="icon">
                          <CustomerdashboardIcon />
                        </div>
                        <div className="info">
                          <h4 className="value">
                            {totalCreditAvailableData.totalCreditAvailable}
                          </h4>
                        </div>
                      </div>
                      <div className="progressBox">
                        <span className="progressValue progressValue--primary">
                          {totalCreditAvailableData.totalCreditsCurrentPlan}
                        </span>
                        <div className="progressbar small">
                          <div
                            className="progress"
                            style={{
                              width:
                                totalCreditAvailableData.totalCreditPrcentage,
                            }}
                          ></div>
                        </div>
                        <span className="progressValue">
                          {totalCreditAvailableData.totalCreditAvailable}/
                          {totalCreditAvailableData.totalCredits} Credits
                          Available
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="dashboardWrap__head__item">
                    <div className="card card--sad">
                      <div className="card__header">
                        <h3 className="title">Credits Used</h3>
                        <div className="form__Field">
                          <select
                            id="AllCustomers"
                            className="form__select form__select--sm"
                            value={creditUsedPeriod}
                            onChange={(e) =>
                              setCreditUsedPeriod(e.target.value)
                            }
                          >
                            <option value="" selected disabled>
                              -Select-
                            </option>
                            {CallSummaryDropDown
                              ? CallSummaryDropDown.map((option) => (
                                  <option value={option?.value}>
                                    {option?.label}
                                  </option>
                                ))
                              : ""}
                          </select>
                        </div>
                      </div>
                      <div className="card__info">
                        <div className="icon">
                          <SmallCoinIcon />
                        </div>
                        <div className="info">
                          <h4 className="value">
                            {creditUsedData.totalCreditsUsed}
                          </h4>
                        </div>
                      </div>
                      <div className="progressBox">
                        <span className="progressValue progressValue--primary">
                          {creditUsedData.planName}
                        </span>
                        <div className="progressbar small">
                          <div
                            className="progress"
                            style={{
                              width: creditUsedData.totalCreditPrcentage,
                            }}
                          ></div>
                        </div>
                        <span className="progressValue">
                          {creditUsedData.creditsAvailable}/
                          {creditUsedData.totalCredits} Credits Available
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="cardRow cardRow__2">
            <div className="col">
              <div className="card radius_0">
                <div className="card__header">
                  <h3 className="title">Bot Failure</h3>
                  <div className="form__Field">
                    <select
                      id="AllCustomers"
                      className="form__select form__select--sm"
                      value={selectedBotFailureAssistant}
                      onChange={(e) =>
                        setSelectedBotFailureAssistant(e.target.value)
                      }
                    >
                      <option value="" selected disabled>
                        -Select-
                      </option>
                      <option value="all" selected="">
                        All Assistants
                      </option>
                      {assistants
                        ? assistants.map((assistant) => (
                            <option value={assistant.id}>
                              {assistant.name}
                            </option>
                          ))
                        : ""}
                    </select>
                  </div>
                </div>
                <div className="card__body">
                  <LineChart
                    height={300}
                    colors={["#8b58f1"]}
                    series={[{ data: botFailureChartData }]}
                    xAxis={[
                      {
                        scaleType: "point",
                        data: botFailureChartLabelData,
                        label: "Day of the week",
                      },
                    ]}
                    yAxis={[
                      {
                        tickMinStep: hasChartDataValue(botFailureChartData)
                          ? 1
                          : undefined,
                        label: "Number of calls",
                      },
                    ]}
                  />
                </div>
              </div>
            </div>
            <div className="col">
              <div className="card radius_0">
                <div className="card__header">
                  <h3 className="title">Assistant Metrics</h3>
                  <div className="form__Field">
                    <select
                      id="AllCustomers"
                      className="form__select form__select--sm"
                      value={callSummaryPeriod}
                      onChange={(e) => setCallSummaryPeriod(e.target.value)}
                    >
                      <option value="" selected disabled>
                        -Select-
                      </option>
                      {CallSummaryDropDown
                        ? CallSummaryDropDown.map((option) => (
                            <option value={option?.value}>
                              {option?.label}
                            </option>
                          ))
                        : ""}
                    </select>
                  </div>
                </div>
                {Array.isArray(callSummaryData?.data) &&
                callSummaryData?.data?.length ? (
                  <div className="card__body">
                    <div className="tableWrap">
                      <div
                        className="tableContainer"
                        style={{ height: "350px" }}
                      >
                        <table className="table">
                          <thead>
                            <tr>
                              <th>
                                <div className="sortingDiv">Name</div>
                              </th>
                              <th>
                                <div className="sortingDiv">Conversations</div>
                              </th>
                              <th>
                                <div className="sortingDiv">Bot Failure</div>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {callSummaryData?.data?.map(
                              (summaryData, index) => (
                                <tr
                                  key={`${summaryData?.name}-${summaryData?.conversationsCount}-${index}`}
                                >
                                  <td>
                                    <div className="profile">
                                      {summaryData?.avatar ? (
                                        <div className="profile__image">
                                          <img
                                            src={summaryData?.avatar}
                                            alt="avatar"
                                          />
                                        </div>
                                      ) : (
                                        <div className="profile__initials">
                                          {String(summaryData?.name)[0]}
                                        </div>
                                      )}
                                      <span className="profile__name">
                                        {summaryData?.name}
                                      </span>
                                    </div>
                                  </td>
                                  <td>
                                    <div className="cellText">
                                      <span className="cellText__dark">
                                        {summaryData?.conversationsCount}
                                      </span>
                                    </div>
                                  </td>
                                  <td>
                                    <div className="cellText">
                                      <span className="cellText__dark">
                                        {summaryData?.botFailureCount}
                                      </span>
                                    </div>
                                  </td>
                                </tr>
                              )
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="no-data">No Record found</div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
